module.exports = __webpack_public_path__ + "img/logo.fe9c9be7.png";